module.exports = __webpack_public_path__ + "static/media/portfolio.1f3d4711.jpeg";